import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import Referenzen from './referenzen';
function Home () {

    return (
        <div className="mainContentWrapper">

            <div className="contentContainer">
                
                <div className="contentColumns ">
                    <div className="landingleft slideInLeft marginHundred">
                        <div className='contentCentered'>
                            <h2>sys.team software GmbH</h2>
                            <br/>   

                            <p>Was können wir für Sie tun?</p>
                            <br/>    
                            <p>Wir haben unsere Stärken dort, wo die Anforderungen über den Einsatz 
                            von Standardsoftware hinausgehen und die Produkte auf spezielle 
                            Gegebenheiten zugeschnitten werden müssen.</p>
                        </div>
                        
                    </div>
                    <div className="landingright slideInRight ">
                        <img src={'/assets/img/wuerfel-02-5.jpg'}/>
                    </div>

                </div>

                <div className="contentColumns">

                    <div className="landingleft slideInLeft">
                         <div className='contentCentered'>
                            <p>Schwerpunkte unserer Arbeit sind:</p>
                            <br/>
                            <ul>
                                <li>B2B Anwendungen in den Bereichen Datawarehouse und Datamining</li>   
                                <li>hochspezialisierter Abrechnungssysteme im Desktop Bereich</li> 
                                <li>Hybridlösungen für den Außendienst zur Auftragserfassung und Datenanalyse vor Ort.</li> 
                                <li>Hybridlösungen für die Redaktion und Veröffentlichung von Verbandsinformationen.</li> 
                                <li>mandantenfähige Shopsysteme</li>  
                            </ul>   
                        </div>    

                        
                    </div>
                    <div className="landingright slideInRight">
                        <div className='contentCentered'>
                            <p>Dazu bieten wir:</p>
                            <br/>
                            <ul>
                                <li>eine weitreichende Beratung</li>
                                <li>eine sinnvolle Konzeption</li>
                                <li>eine optimale technische Umsetzung</li>
                                <li>kreative Ideen mit Liebe zum Detail</li>
                            </ul>   
                        </div> 
                    </div>

                </div>

            </div>

            

            <Referenzen />

        </div>
    )

}

export default Home;